import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Dashboard from "./pages/dashboard"
import About from "./pages/About"
import Adding from "./pages/adding"
import Login from "./pages/login"
import Signup from "./pages/signup"
import Medicine from "./pages/medicine"
import Profile from "./pages/Profile"

import PersonalInfo from "./pages/PersonalInfo"
import SupplierDetails from "./pages/supplier"
import ProductsLanding from "./pages/products"
import AddProduct from "./pages/products-add"
import ProductsList from "./pages/products-list"

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/about" element={<About />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/adding" element={<Adding />} />
        <Route path="/medicine" element={<Medicine />} />
        <Route path="/profile" element={<Profile />} />
        
        <Route path="/personal-info" element={<PersonalInfo />} />
        <Route path="/products" element={<ProductsLanding />} />
        <Route path="/products/add" element={<AddProduct />} />
        <Route path="/products/list" element={<ProductsList />} />
        <Route path="/supplier/:id" element={<SupplierDetails />} />
      </Routes>
    </Router>
  )
}

export default App
